import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { postRequest } from '../../helpers/apiHandler';
import config from '../../config/Constant';
import CustomAlert from '../../components/CustomAlert';
import { GreenIconSVG } from '../SVG/GreenIconSVG';
import CloseIcon from '../SVG/CloseIcon';
import { reloadContactList } from '../../store/actions/reduxAction';
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import { MultiSelectStyle } from '../../helpers/MultiSelectStyle';
import InfoIcon from '../../assets/icon-info.svg';

const ContactEditList = (props) => {
  const { openModalEdit, setOpenModalEdit, selectedContactList, access_token, reloadContactList, allTags } =
    props;

  const [contactListName, setContactListName] = useState('');
  const [tagOptions, setTagOptions] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  useEffect(() => {
    if (openModalEdit === true) {
      setContactListName(selectedContactList.name);
      setTagOptions(allTags);
      setSelectedTags(selectedContactList.tags.map((tag) => ({ value: tag, label: tag })));
    }
  }, [openModalEdit]);

  const handleSave = () => {
    const data = {
      name: contactListName,
      lead_list_id: selectedContactList.id,
      tags: selectedTags.map((tag) => tag.value),
    };
    postRequest(`/v2/contacts-edit-contact-list`, data, access_token.token, (res) => {
      if (res.success) {
        // Handle success if needed
        handleCloseModal();
        reloadContactList();
        setAlertState({
          message: 'Contact successfully saved',
          show: true,
          variant: 'success',
        });
      } else {
        setAlertState({
          message: `Sorry, There was an error saving contact`,
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  const handleCloseModal = () => {
    setOpenModalEdit(false);
    // Reset form fields
    setContactListName('');
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <>
      <Modal
        show={openModalEdit}
        animation={true}
        onHide={handleCloseModal}
        className="modal-form-contact"
        centered
      >
        <Modal.Body>
          <CustomAlert
            message={alertState.message}
            show={alertState.show}
            variant={alertState.variant}
            closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
          />
          <CloseIcon handleModalClose={handleCloseModal} />
          <GreenIconSVG />
          <Modal.Title as="h4" style={{ margin: '8px 0 16px' }}>
            Edit Contact List
          </Modal.Title>
          {/* <p>Edit the contact list name</p> */}
          <Form>
            <Form.Group>
              <Form.Label>Contact List Name</Form.Label>
              <Form.Control
                value={contactListName}
                onChange={(e) => {
                  const { value } = e.target;
                  if (value.length <= 30) {
                    setContactListName(value);
                  }
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Tag(s)</Form.Label>
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id="tooltip-name">
                    Remove any existing tags or select more pre-made tags from the dropdown menu.
                  </Tooltip>
                }
              >
                <span className="ml-2"><img src={InfoIcon} style={{ width: '14px' }}></img></span>
              </OverlayTrigger>
              <CreatableSelect
                options={tagOptions.map((tag) => ({ value: tag, label: tag }))}
                isMulti
                value={selectedTags}
                onChange={setSelectedTags}
                styles={MultiSelectStyle}
                placeholder={tagOptions && tagOptions.length > 0 ? "Select..." : "No created tags"}
              />
            </Form.Group>
            <Form.Group>
              <Button variant="primary" style={{ minWidth: 160 }} onClick={handleSave}>
                Save
              </Button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  const { access_token, user } = state.auth;

  return {
    access_token,
    user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  reloadContactList: () => dispatch(reloadContactList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactEditList);
